import { useMemo } from 'react'
import { AdminAPI, getFragment, GraphQL, SharedAPI } from '@guestgoodie/graphql'
import usePaginatedQuery from '@/hooks/usePaginatedQuery'

export type QueryVariables = {
  filter: GraphQL.QueryGoodiesFilter
  sort: GraphQL.QueryGoodiesSort
}

export default function usePaginatedGoodies(variables: QueryVariables) {
  const { items: fragmentItems, ...rest } = usePaginatedQuery(
    AdminAPI.goodie.QUERY,
    variables,
    {
      document: AdminAPI.goodie.CHANGED,
      typename: 'Goodie'
    }
  )

  const items = useMemo(() => {
    return fragmentItems?.map(item =>
      getFragment(SharedAPI.goodie.GOODIE_FRAGMENT, item)
    )
  }, [fragmentItems])

  return {
    items,
    ...rest
  }
}
